export const nav = {
    permissao: 'deck.times:ver',
    section: 'Configuracao',
    title: 'Times',
    icon: 'diversity_3',
    route: '/times',
    sequence: 41,
};

export default [
    {
        path: '/times',
        name: 'times',
        component: () => import('./pages/TimesPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.times:ver' },
    },
];
